import React from 'react';
import { ShimmerThumbnail } from 'react-shimmer-effects';

const thumbnailProps = {
    width: 200,
    height: 200,
    center: false,
    rounded: true,
    fitOnFrame: false,
};

const ThumbnailGallery: React.FC = () => {
    const thumbnails = Array.from({ length: 10 }, (_, index) => (
        <ShimmerThumbnail key={index} {...thumbnailProps} className="w-full " />
    ));

    return (
        <div className="flex flex-wrap gap-6 justify-center mt-12 w-full ">
            {thumbnails}
        </div>
    );
};

export default ThumbnailGallery;
